export const moeda = (v) =>
  v === null || v === undefined || v === ""
    ? "Não informado"
    : new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL"
      }).format(Number(v));
export const numero = (v) => new Intl.NumberFormat("pt-BR").format(v || 0);
export const cpfExibicao = (v) =>
  v
    ? String(v)
        .replace(/\D/g, "")
        .replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4")
    : "Não informado";
export const dataExibicao = (v) => {
  if (!v) return "Não informado";
  if (typeof v === "string" && /^\d{4}-\d{2}-\d{2}$/.test(v))
    return v.split("-").reverse().join("/");
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? String(v) : d.toLocaleString("pt-BR");
};
export const competenciaExibicao = (v) =>
  !v
    ? "Sem competência"
    : /^\d{4}$/.test(v)
    ? `13º / ${v}`
    : /^\d{4}-\d{2}$/.test(v)
    ? `${v.slice(5)}/${v.slice(0, 4)}`
    : v;

export const TIPOS = {
  1000: "Empregador",
  1005: "Estabelecimentos",
  1010: "Rubricas",
  1020: "Lotações",
  1070: "Processos",
  1200: "Remuneração RGPS",
  1202: "Remuneração RPPS",
  1207: "Benefícios RPPS",
  1210: "Pagamentos",
  1298: "Reabertura",
  1299: "Fechamento",
  2200: "Admissão",
  2205: "Alteração cadastral",
  2206: "Alteração contratual",
  2210: "Acidente de trabalho",
  2220: "Monitoramento de saúde",
  2230: "Afastamento",
  2231: "Cessão",
  2240: "Condições ambientais",
  2298: "Reintegração",
  2299: "Desligamento",
  2300: "Trabalhador sem vínculo",
  2306: "Alteração sem vínculo",
  2399: "Término sem vínculo",
  2400: "Cadastro de beneficiário",
  2405: "Alteração de beneficiário",
  2410: "Cadastro de benefício",
  2416: "Alteração de benefício",
  2418: "Reativação de benefício",
  2420: "Término de benefício",
  3000: "Exclusão"
};
export const ESTADOS = {
  1: "Em fila",
  2: "Em processamento",
  3: "Processado com sucesso",
  4: "Erro no processamento",
  5: "Erro"
};
export const TOTALIZADORES = {
  5001: "Contribuições sociais por trabalhador",
  5002: "Imposto de renda por beneficiário",
  5003: "FGTS por trabalhador",
  5011: "Contribuições sociais consolidadas",
  5012: "IRRF consolidado",
  5013: "FGTS consolidado",
  5501: "Tributos de processo trabalhista"
};

export function percorrer(valor, visitar, caminho = "", contexto = {}) {
  if (Array.isArray(valor))
    return valor.forEach((v, i) =>
      percorrer(v, visitar, `${caminho}[${i + 1}]`, contexto)
    );
  if (!valor || typeof valor !== "object") return;
  const ctx = { ...contexto };
  [
    "matricula",
    "nrBeneficio",
    "perRef",
    "ideDmDev",
    "nrInsc",
    "codLotacao"
  ].forEach((k) => {
    if (valor[k] !== undefined) ctx[k] = valor[k];
  });
  visitar(valor, caminho, ctx);
  Object.entries(valor).forEach(([k, v]) => {
    if (v && typeof v === "object")
      percorrer(v, visitar, caminho ? `${caminho}/${k}` : k, ctx);
  });
}

export function demonstrativos(dados = {}) {
  const grupos = [];
  percorrer(dados, (obj, path) => {
    if (!Array.isArray(obj.dmDev)) return;
    obj.dmDev.forEach((dev, i) => {
      const rubricas = [];
      percorrer(
        dev,
        (item, itemPath, ctx) => {
          if (item.codRubr !== undefined && item.vrRubr !== undefined)
            rubricas.push({ ...ctx, ...item, caminho: itemPath });
        },
        `${path ? path + "/" : ""}dmDev[${i + 1}]`,
        { perRef: dados.ideEvento?.perApur }
      );
      if (rubricas.length)
        grupos.push({
          id: dev.ideDmDev || `${i + 1}`,
          categoria: dev.codCateg,
          beneficio: dev.nrBeneficio,
          rubricas
        });
    });
  });
  return grupos;
}

export function pagamentos(dados = {}) {
  const rows = [];
  percorrer(dados, (obj, path) => {
    if (Array.isArray(obj.infoPgto))
      obj.infoPgto.forEach((p, i) =>
        rows.push({ ...p, caminho: `${path}/infoPgto[${i + 1}]` })
      );
  });
  return rows;
}

const ROTULOS = {
  nmTrab: "Nome",
  nmBenefic: "Nome do beneficiário",
  matricula: "Matrícula",
  nrBeneficio: "Número do benefício",
  codCateg: "Categoria",
  dtAdm: "Admissão",
  dtInicio: "Início",
  dtAlteracao: "Alteração",
  dtIniAfast: "Início do afastamento",
  dtTermAfast: "Fim do afastamento",
  codMotAfast: "Motivo do afastamento",
  observacao: "Observação",
  dtDeslig: "Desligamento",
  mtvDeslig: "Motivo do desligamento",
  dtIniBeneficio: "Início do benefício",
  dtTermBeneficio: "Término do benefício",
  mtvTermino: "Motivo do término",
  dtReativ: "Reativação",
  dtEfetRetorno: "Retorno",
  dtAcid: "Data do acidente",
  dtAso: "Data do ASO",
  resAso: "Resultado do ASO",
  codAgNoc: "Agente nocivo",
  dscAgNoc: "Descrição do agente",
  codRubr: "Código da rubrica",
  ideTabRubr: "Tabela de rubricas",
  dscRubr: "Descrição da rubrica",
  tpRubr: "Tipo da rubrica",
  codIncCP: "Incidência previdenciária",
  codIncIRRF: "Incidência IRRF",
  codIncCPRP: "Incidência RPPS",
  nrProc: "Processo",
  iniValid: "Início da validade",
  fimValid: "Fim da validade",
  tpEvento: "Evento excluído",
  nrRecEvt: "Recibo excluído",
  evtRemun: "Remuneração informada",
  evtPgtos: "Pagamento informado",
  evtBenPrRP: "Benefícios informados",
  compSemMovto: "Competência sem movimento",
  cadIni: "Cadastro inicial"
};
export function informacoesRelevantes(dados = {}) {
  const fields = [];
  const counts = {};
  const listas = {
    dependente: "Dependentes",
    infoDep: "Dependentes do IR",
    agNoc: "Agentes nocivos",
    exame: "Exames",
    ideEstabLot: "Estabelecimentos/lotações",
    ideEstab: "Estabelecimentos",
    infoIRCR: "Grupos de IR",
    penAlim: "Pensões alimentícias",
    infoProcJud: "Processos judiciais"
  };
  percorrer(dados, (obj, path) =>
    Object.entries(obj).forEach(([k, v]) => {
      if (listas[k] && Array.isArray(v))
        counts[listas[k]] = (counts[listas[k]] || 0) + v.length;
      if (
        ROTULOS[k] &&
        !path.includes("itensRemun") &&
        v !== null &&
        typeof v !== "object" &&
        v !== "" &&
        !fields.some((f) => f.label === ROTULOS[k] && f.value === String(v))
      )
        fields.push({
          label: ROTULOS[k],
          value: k.startsWith("dt") ? dataExibicao(v).split(",")[0] : String(v),
          path: `${path}/${k}`
        });
    })
  );
  return { fields, counts };
}

// XPath do eSocial usa índices iniciados em 1. Sem índice, só há associação segura se houver um único candidato.
export function localizarErro(dados, localizacao) {
  if (!localizacao || !localizacao.startsWith("/eSocial/")) return null;
  const partes = localizacao.split("/").filter(Boolean).slice(2);
  let candidatos = [{ valor: dados, contexto: {} }];
  for (const parte of partes) {
    const m = parte.match(/^([\w]+)(?:\[(\d+)\])?$/);
    if (!m) return null;
    const seguintes = [];
    candidatos.forEach(({ valor: obj, contexto }) => {
      if (
        !obj ||
        typeof obj !== "object" ||
        !Object.prototype.hasOwnProperty.call(obj, m[1])
      )
        return;
      const ctx = { ...contexto };
      ["ideDmDev", "codRubr", "ideTabRubr", "vrRubr", "vrLiq"].forEach((k) => {
        if (obj[k] !== undefined) ctx[k] = obj[k];
      });
      const value = obj[m[1]];
      const values = Array.isArray(value)
        ? m[2]
          ? [value[Number(m[2]) - 1]]
          : value
        : !m[2] || m[2] === "1"
        ? [value]
        : [];
      values
        .filter((v) => v !== undefined)
        .forEach((valor) => seguintes.push({ valor, contexto: ctx }));
    });
    candidatos = seguintes;
  }
  return candidatos.length === 1 ? candidatos[0] : null;
}

export const ROTULOS_TOTALIZADORES = {
  valor: "Valor declarado",
  vrBase: "Base de cálculo",
  vrBcCp00: "Base previdenciária",
  vrBcCp15: "Base previdenciária · 15 anos",
  vrBcCp20: "Base previdenciária · 20 anos",
  vrBcCp25: "Base previdenciária · 25 anos",
  vrDescSeg: "Desconto do segurado",
  vrCpSeg: "Contribuição do segurado",
  vrCsSeg: "Contribuição do segurado",
  vrSalFam: "Salário-família",
  vrSalMat: "Salário-maternidade",
  vrBcFGTS: "Base do FGTS",
  vrBcFGTS13: "Base do FGTS · 13º salário",
  vrFGTS: "FGTS",
  vrFGTS13: "FGTS · 13º salário",
  vlrRendTrib: "Rendimentos tributáveis",
  vlrRendTrib13: "Rendimentos tributáveis · 13º salário",
  vlrRendMoleGrave: "Rendimentos isentos por moléstia grave",
  vlrRendIsen65: "Parcela isenta · 65 anos",
  vlrPrevOficial: "Previdência oficial",
  vlrPrevOficial13: "Previdência oficial · 13º salário",
  vlrDedDep: "Dedução por dependentes",
  vlrDedDep13: "Dedução por dependentes · 13º salário",
  vlrDedPenAlim: "Dedução de pensão alimentícia",
  vlrCRMen: "IRRF mensal apurado",
  vlrCR13Men: "IRRF do 13º salário apurado",
  vrCRMen: "IRRF mensal consolidado",
  vrCR13Men: "IRRF do 13º salário consolidado",
  vlrIRRF: "IRRF",
  vlrRendBruto: "Rendimento bruto",
  vrLiq: "Valor líquido",
  perApur: "Competência",
  cpfBenef: "CPF do beneficiário",
  cpfTrab: "CPF do trabalhador",
  ideDmDev: "Demonstrativo",
  tpInfoIR: "Tipo de informação de IR",
  CRMen: "Código de receita mensal",
  CR13Men: "Código de receita · 13º salário",
  codReceita: "Código de receita",
  nrRecArqBase: "Recibo do evento de origem",
  matricula: "Matrícula",
  codCateg: "Categoria"
};

export function analisarXml(xml) {
  if (!xml || typeof xml !== "string")
    return { erro: "XML não disponível.", campos: [] };
  const doc = new DOMParser().parseFromString(xml, "application/xml");
  if (doc.getElementsByTagName("parsererror").length)
    return { erro: "O XML retornado não pôde ser interpretado.", campos: [] };
  const campos = [];
  function visita(node, path, contexto = [], indice = "") {
    if (["Signature", "X509Certificate"].includes(node.localName)) return;
    const filhos = Array.from(node.children);
    const next = `${path}/${node.localName}${indice}`;
    const referencias = [
      "ideDmDev",
      "matricula",
      "codReceita",
      "CRMen",
      "CR13Men",
      "codLotacao",
      "tpInfoIR",
      "perRef"
    ];
    const ctx = [
      ...contexto,
      ...filhos
        .filter((f) => referencias.includes(f.localName))
        .map(
          (f) =>
            `${
              ROTULOS_TOTALIZADORES[f.localName] || f.localName
            }: ${f.textContent.trim()}`
        )
    ];
    if (!filhos.length && node.textContent?.trim())
      campos.push({
        nome: node.localName,
        rotulo: ROTULOS_TOTALIZADORES[node.localName] || node.localName,
        contexto: ctx.join(" · "),
        caminho: next,
        valor: node.textContent.trim(),
        monetario: /^(vr|vlr|valor)/i.test(node.localName)
      });
    filhos.forEach((n) => {
      const iguais = filhos.filter((f) => f.localName === n.localName);
      visita(
        n,
        next,
        ctx,
        iguais.length > 1 ? `[${iguais.indexOf(n) + 1}]` : ""
      );
    });
  }
  visita(doc.documentElement, "");
  return { campos };
}
